import { Component, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http'
import { MenuService } from 'app/services/menu.service'
import { CookieService } from 'ngx-cookie-service'

@Component({
  selector: 'app-users-collective',
  templateUrl: './users-collective.component.html',
  styleUrls: ['./users-collective.component.scss']
})
export class UsersCollectiveComponent implements OnInit {

  url 

  constructor(
    private http: HttpClient,
    private menuService: MenuService,
    private cookies: CookieService
  ) { }

  ngOnInit(): void {
    this.url = this.menuService.getScreen('COLLECTIVEUSERS').url + this.cookies.get('at') + '&mode='+(localStorage.getItem('theme') == 'grey' ? 'light' : 'dark')
  }

}
